import { RootState } from '../store';

export const NeurojsonSelector = (state: RootState) => state.neurojson;
